export function normalizeWordPressSiteUrl(url = "") {
  const rawUrl = String(url || "").trim();
  if (!rawUrl) return "";

  return rawUrl
    .replace(/\/+$/, "")
    .replace(/\/wp-admin(?:\/.*)?$/i, "")
    .replace(/\/wp-json(?:\/wp\/v2)?$/i, "")
    .replace(/\/+$/, "");
}
